import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let OneServicePageThunk = createAsyncThunk(
	"Services/OneServicePageThunk",
	async (arg, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let res = await axios.get(`/api/admin/services/${arg?.id}`);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data.data);
		}
	}
);
